<template>
  <v-app id="duette-page">
    <Menu />
    <v-container id="duette" grid-list-lg>

      <v-layout row wrap>
        <!-- Duette BLock -->
        <v-flex xs12>
          <v-form ref="phaseOne" @submit.prevent="goToPhaseTwo">
            <v-card class="card-expansion">
              <v-toolbar @click="phaseOne" class='elevation-0'
                :class="stepOne + stepOneActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepOne + stepOneActive ? require('../assets/ui-elements/step1-active.png') : require('../assets/ui-elements/step1.png')"
                  alt="">
                <v-card-title dark> <span
                    :class="stepOne + stepOneActive ? 'step-tile-active' : 'step-title'">Materiaal</span>
                </v-card-title>
                <v-spacer></v-spacer> 
                <h4 class="mr-5 activeProductTitle">{{duettes | formatDuettes}}</h4>
                <v-icon :class="stepOne + stepOneActive ? 'step-icon-active' : ''">{{toggleIcon(stepOne)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepOne">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="duettes == 'lichtdoorlatend' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="duettes" type="radio" name="Lichtdoorlatend"
                              value="lichtdoorlatend" required>
                            <img class="gordijnen-product-image pt-3 ml-4" src="../assets/gordijnen/Lichtdoorlatend.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>

                        </div>
                        <h4 class="mt-2 product-tile-title">Lichtdoorlatend

                        </h4>
                      </v-flex>
                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="duettes == 'verduisterend' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="duettes" type="radio" name="Verduisterend"
                              value="verduisterend" required>
                            <img class="gordijnen-product-image pt-3 ml-4" src="../assets/gordijnen/Verduisterend.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 product-tile-title">Verduisterend</h4>
                      </v-flex>
                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 mt-5>
                        <span class="type-extra-title">Breedte:</span>
                        <v-radio-group :rules="widthRules" v-model="stofbreedte">
                          <v-radio label="AO20" value="ao20"></v-radio>
                          <v-radio label="BB24 +GPP" value="bb24+gpp"></v-radio>
                          <v-radio label="BB24" value="bb24"></v-radio>
                          <v-radio label="AL20 / SmartCord" value="al20"></v-radio>
                        </v-radio-group>
                      </v-flex>

                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen BB24 Block -->
        <v-flex xs12 v-if="stofbreedte == 'bb24'">
          <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle">B {{bb24Width}} x H {{bb24Height}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="bb24Width" :max="bb24MaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{bb24MaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="bb24Width" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="bb24Height" :max="bb24MaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{bb24MaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="bb24Height" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen BB24+GPP Block -->
        <v-flex xs12 v-if="stofbreedte == 'bb24+gpp'">
          <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle">B {{bb24GPPWidth}} x H {{bb24GPPHeight}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="bb24GPPWidth" :max="bb24MaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{bb24MaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="bb24GPPWidth" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="bb24GPPHeight" :max="bb24MaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{bb24MaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="bb24GPPHeight" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen AO20 Block -->
        <v-flex xs12 v-if="stofbreedte == 'ao20'">
          <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle">B {{ao20Width}} x H {{ao20Height}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="ao20Width" :max="ao20MaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{ao20MaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="ao20Width" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="ao20Height" :max="ao20MaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{ao20MaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="ao20Height" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afemetingen AL20 Block -->
        <v-flex xs12 v-if="stofbreedte == 'al20'">
          <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle">B {{al20Width}} x H {{al20Height}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="al20Width" :max="al20MaxWidth"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{al20MaxWidth}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="al20Width" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="al20Height" :max="al20MaxHeight"></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{al20MaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="al20Height" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Totaal Block -->
        <v-flex xs12>
          <v-form @submit.prevent="submitForm" ref="duettesForm">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseThree" class='elevation-0'
                :class="stepThree + active ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepThree + active  ? require('../assets/ui-elements/step3-active.png') : require('../assets/ui-elements/step3.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepThree + active ? 'step-tile-active' : 'step-title'">Totaal</span>
                </v-card-title>
                <v-spacer></v-spacer>
 <h4 class="mr-5 text-truncate activeProductTitle">&#8364; {{totalPrice | currency}}</h4>
                <v-icon :class="stepThree + active ? 'step-icon-active' : ''">{{toggleIcon(stepThree)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepThree">
                  <v-container grid-list-xs>
                    <v-layout row wrap>

                      <!-- Type stof -->
                      <v-flex xs4 sm2 md2><span class="total-title">Type stof:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">{{duettes | formatDuettes}}</span>
                      </v-flex>


                          <v-flex xs4 sm2 md2><span class="total-title">Stof breedte:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">{{stofbreedte | formatDuettesOptions}}</span>
                      </v-flex>

                      <!-- Afmetingen -->
                      <v-flex xs4 sm2 md2><span class="total-title">Afmeting:</span></v-flex>
                      <v-flex xs8 sm10 md10>
                        <span v-if="stofbreedte == 'bb24'" class="total-item">Breedte {{bb24Width}} mm x Hoogte {{bb24Height}} mm</span>
                        <span v-if="stofbreedte == 'bb24+gpp'" class="total-item">Breedte {{bb24GPPWidth}} mm x Hoogte {{bb24GPPHeight}} mm</span>
                        <span v-if="stofbreedte == 'ao20'" class="total-item">Breedte {{ao20Width}} mm x Hoogte {{ao20Height}} mm</span>
                        <span v-if="stofbreedte == 'al20'" class="total-item">Breedte {{al20Width}} mm x Hoogte {{al20Height}} mm</span>
                      </v-flex>

                      <!-- Ruimte/Raam + Totale Prijs & Button -->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4 sm2 md2><span class="total-title">Aantal</span></v-flex>
                          <v-flex xs6 sm10 md10>
                            <v-text-field class="quantity-input" v-model="quantity" type="number" outline
                              :rules="quantityRules"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <span class="total-title">Ruimte / raam</span>
                          </v-flex>
                          <v-flex xs8 sm8 md8>
                            <v-text-field class='price-input' v-model="room" type="text" outline
                              label="Typ hier een naam voor de ruimte of het raam">
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center xs12>
                            <hr class="seperator-line">
                          </v-flex>
                          <v-flex xs2 text-xs-left>
                            <span class="end-total-title">Totaal</span>
                          </v-flex>
                          <v-flex xs10 text-xs-right>
                            <h2 class="price-total"> <span class="price-title mr-3">Prijs compleet,
                                incl. BTW </span> €
                              {{totalPrice | currency}}</h2>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
            <v-flex id="col-btn" xs12 text-xs-right>
              <v-btn type="submit" color="primary" depressed class="text-none form-btn">Plaats op lijst
                <v-icon class="icon-size" right>fal fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>

    </v-container>
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>
</template>


<script>
import Menu from '@/components/Menu';
import Messages from '@/services/messages.service'; // Meldingen
import SnackBar from '@/components/SnackBar'; // Messages Container
import ApiService from '@/services/api.service'; // ApiService
import FormatService from '@/services/format.service'; // Filters

export default {
  components: {
    Menu,
    SnackBar
  },
  data() {
    return {
      active: false,
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepOneActive: false,
      stepTwoActive: false,
      height: 0,
      width: 0,
      max: 10000,
      bb24Width: null,
      bb24Height: null,
      bb24GPPHeight: null,
      bb24GPPWidth: null,
      bb24MaxWidth: 1300,
      bb24MaxHeight: 2300,
      ao20MaxWidth: 3000,
      ao20MaxHeight: 2600,
      ao20Width: null,
      ao20Height: null,
      al20MaxWidth: 3600,
      al20MaxHeight: 3000,
      al20Width: null,
      al20Height: null,
      duettes: 'lichtdoorlatend',
      stofbreedte: 'bb24',
      price: 0,
      productPrijs: 0,
      quantity: 1,
      room: '',
      error: false,
      errorMsg: '',
      snackbar: false,
      color: '',
      messageTxt: '',
      quantityRules: [quantity => !!quantity || Messages.QuantityValidationMessage],
      widthRules: [width => !!width || Messages.ChoiceValidationMessage]
    }
  },
  computed: {
    totalPrice() {
      return this.quantity * this.productPrijs
    }
  },
  methods: {
    getBB24Price() {
     if(this.bb24Width > 249 && this.bb24Height > 249){
        ApiService.getDuettePlissePrice({
        stoftype: this.duettes,
        stofbreedte: this.stofbreedte,
        breedte: this.bb24Width,
        hoogte: this.bb24Height
      }).then(response => {
        this.productPrijs = response;
      })
     }
    },
      getBB24GPPPrice() {
     if(this.bb24GPPWidth > 249 && this.bb24GPPHeight > 249){
        ApiService.getDuettePlissePrice({
        stoftype: this.duettes,
        stofbreedte: this.stofbreedte,
        breedte: this.bb24GPPWidth,
        hoogte: this.bb24GPPHeight
      }).then(response => {
        this.productPrijs = response;
      })
     }
    },
    getAO20Price() {
  if(this.ao20Width > 249 && this.ao20Height > 249){
        ApiService.getDuettePlissePrice({
        stoftype: this.duettes,
        stofbreedte: this.stofbreedte,
        breedte: this.ao20Width,
        hoogte: this.ao20Height
      }).then(response => {
        this.productPrijs = response;
      })
  }
    },
    getAL20Price() {
     if(this.al20Width > 249 && this.al20Height > 249){
        ApiService.getDuettePlissePrice({
        stoftype: this.duettes,
        stofbreedte: this.stofbreedte,
        breedte: this.al20Width,
        hoogte: this.al20Height
      }).then(response => {
        this.productPrijs = response;
      })
     }
    },
    phaseOne() {
      this.stepOne = !this.stepOne;
      this.error = false;
    },
    phaseTwo() {
      this.stepTwo = !this.stepTwo;
      this.error = false;
    },
    phaseThree() {
      this.stepThree = !this.stepThree;
      this.error = false;
    },
    goToPhaseTwo(e) {
  

      if (e.target.elements.Lichtdoorlatend.validity.valid ||
        e.target.elements.Verduisterend.validity.valid) {
        this.$nextTick(() => {
          if (this.$refs.phaseOne.validate()) {
            this.stepOne = false;
            this.stepTwo = true;
            this.stepOneActive = true;
            if (this.stofbreedte == 'bb24') {
              this.getBB24Price()
            }
            if(this.stofbreedte == 'bb24+gpp'){
              this.getBB24GPPPrice()
            }
            if (this.stofbreedte == 'ao20') {
              this.getAO20Price()
            }
            if (this.stofbreedte == 'al20') {
              this.getAL20Price()
            }
          }
        })
      } else {
        this.$refs.phaseOne.validate()
        this.error = true;
        this.errorMsg = Messages.MaterialValidationMessage;
      }
    },
    goToPhaseThree() {
      if (this.stofbreedte == 'bb24') {
        if (this.bb24Width > 249 & this.bb24Height > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = true;
          this.stepTwoActive = true;

          this.getBB24Price()
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }

      if (this.stofbreedte == 'bb24+gpp') {
        if (this.bb24GPPWidth > 249 && this.bb24GPPHeight > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = true;
          this.stepTwoActive = true;
       this.getBB24GPPPrice()
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }
      if (this.stofbreedte == 'ao20') {
        if (this.ao20Width > 249 && this.ao20Height > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = true;
          this.stepTwoActive = true;
          this.getAO20Price()
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }
      if (this.stofbreedte == 'al20') {
        if (this.al20Width > 249 && this.al20Height > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = true;
          this.stepTwoActive = true;
          this.getAL20Price()
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }
    },
    submitForm() {
      if (this.stofbreedte == 'bb24') {
        if (this.bb24Width > 249 & this.bb24Height > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = false;
          this.stepTwoActive = false;
          this.stepOneActive = false;
          this.snackbar = true;
          this.color = '#006fb3';
          this.messageTxt = Messages.ProductAddedMessage;
          this.getBB24Price()
          this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.duettes,
            stofbreedte: this.stofbreedte,
            breedte: this.bb24Width,
            hoogte: this.bb24Height,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }

      if (this.stofbreedte == 'bb24+gpp') {
        if (this.bb24GPPWidth > 249 && this.bb24GPPHeight > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = false;
          this.stepTwoActive = false;
          this.stepOneActive = false;
          this.snackbar = true;
          this.color = '#006fb3';
          this.messageTxt = Messages.ProductAddedMessage;
            this.getBB24GPPPrice()
          this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.duettes,
            stofbreedte: this.stofbreedte,
            breedte: this.bb24GPPWidth,
            hoogte: this.bb24GPPHeight,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }
      if (this.stofbreedte == 'ao20') {
        if (this.ao20Width > 249 && this.ao20Height > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = false;
          this.stepTwoActive = false;
          this.stepOneActive = false;
          this.snackbar = true;
          this.color = '#006fb3';
          this.messageTxt = Messages.ProductAddedMessage;
          this.getAO20Price()
          this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.duettes,
            stofbreedte: this.stofbreedte,
            breedte: this.ao20Width,
            hoogte: this.ao20Height,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }
      if (this.stofbreedte == 'al20') {
        if (this.al20Width > 249 && this.al20Height > 249) {
          this.stepOne = false;
          this.stepTwo = false;
          this.stepThree = false;
          this.stepTwoActive = false;
          this.stepOneActive = false;
          this.snackbar = true;
          this.color = '#006fb3';
          this.messageTxt = Messages.ProductAddedMessage;
          this.getAL20Price()
          this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            product: this.duettes,
            stofbreedte: this.stofbreedte,
            breedte: this.al20Width,
            hoogte: this.al20Height,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
        } else {
          this.error = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
      }
    },
    inputChecked(e) {
      if (e.target.validity.valid) {
        this.error = false;
      }
    },
    sliderInput(value) {
      if (value > 249) {
        this.error = false;
      }
    },
    toggleIcon(value) {
      if (value) {
        return 'fal fa-minus-circle';
      } else {
        return 'fal fa-plus-circle';
      }
    },
  },
  filters: {
    ...FormatService
  }
}
</script>



<style scoped>
#duette-page {
  background-color: #fff;
}


.card-expansion {
  box-shadow: none;
  border: 1px solid #eaeaea;
}

.type-extra-title {
  color: #006fb3;
  font-size: 15px;
  font-weight: 700;
}

.min {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  top: 0;
  left: 0;
  left: -5%;
  top: -15%;
  color: #b4b4b4;
  font-size: 12px;
  font-weight: 400;
}

.max {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  clear: both;
  right: -55%;
  top: -34%;
  color: #b4b4b4;
  font-size: 12px;
  font-weight: 400;
}

.sizeRange {
  border-radius: 4px;
  display: inline-block;
  width: 120px;
  height: 60px;
  position: relative;
  top: -1em;
  padding: 1em;
  vertical-align: middle;
  line-height: 60px;
}

.info-height {
  color: #707070;
  font-size: 16px;
  font-weight: 400;
}

.size-unit {
  position: relative;
  top: -3em;
  line-height: 30px;
  text-align: center;
}

.product-panel {
  border-top: 3px solid #b4b4b4;
  background-color: #fff;
}

.panel-open {
  border-top: 3px solid #006fb3;
  background-color: #fff;
}

.step-title {
  font-size: 15px;
  font-weight: 700;
  color: #b4b4b4;
}

.step-tile-active {
  font-size: 15px;
  font-weight: 700;
  color: #006fb3;
}

.step-icon-active {
  color: #006fb3;
}

.next-step {
  border-radius: 4px;
  height: 60px;
}

.activeProductTitle {
  color: #b4b4b4;
  font-size: 16px;
  font-weight: 400;
}

.product-tile {
  border: 1px solid #d0d0d0;
}

.product-tile-title {
  font-weight: 400;
  font-size: 19px;
  color: #707070;
}

.gordijnen-product-image {
  position: relative;
  right: 10px;
  width: 25%;
  height: 25%;
}

.selected {
  border: 2px solid #006fb3 !important;
  z-index: 222;
}

.plooi-selected {
  border: 2px solid #006fb3 !important;
}

.seperator-line {
  border: 1px solid #b4b4b4;
}

/* The container */
.radio-container {
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  bottom: -3px;
  right: 10px;
  height: 35px;
  width: 36px;
  background-color: transparent;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input~.checkmark {
  background-color: transparent;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked~.checkmark {
  background-color: #006fb3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
  top: 8px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-image: url('../assets/ui-elements/checkmark.png');
  background-repeat: no-repeat;
}

.gordijnen-product-image {
  width: 50%;
}

.plooi-product-image {
  width: 50%;
}

.sub-product-tile {
  border: 1px solid #eaeaea;
}

.subproduct-tile-title {
  color: #707070;
  font-size: 18px;
  font-weight: 400;
}

.total-title {
  color: #006fb3;
  font-size: 13px;
  font-weight: 700;
}

.price-title {
  color: #006fb3;
  font-size: 13px;
  font-weight: 700;
}


.total-item {
  color: #707070;
  font-size: 13px;
  font-weight: 400;
}

#addToCart {
  border-radius: 4px;
  height: 60px;
  margin: 0 !important;
}

.price-total {
  font-size: 15px;
  color: #006fb3;
  font-weight: 700;
}

.end-total-title {
  font-size: 15px;
  color: #006fb3;
  font-weight: 700;
}

.form-btn {
  border-radius: 4px;
  height: 60px;
  margin: 0 !important;
  width: 180px;
}

.icon-size {
  font-size: 20px;
}

#col-btn {
  padding-right: 0;
  padding-left: 0;
}

@media screen and (max-width: 1024px) {
  .plooi-product-image {
    width: 80%;
  }
}

@media screen and (max-width: 425px) {
  .size-unit {
    position: relative;
    top: -2.5em;
  }

  .form-btn {
    width: 100%;
  }

  #height-help {
    margin: 0 auto;
    text-align: center;
    justify-content: center;
  }

  .info-height {
    font-size: 13px;
  }

  .activeProductTitle {
    font-size: 14px;
  }

  #addToCart {
    width: 100%;
  }

}

@media screen and (max-width: 320px) {
  .size-unit {
    position: relative;
    top: -3em;
  }

  .activeProductTitle {
    display: none;
  }

}
</style>
